export default __webpack_public_path__ + "static/grenette-regular-pro-edc90fe0b16192af609443a6ec33b551.eot";